module.exports = __webpack_public_path__ + "img/11.cb1934ed.png";